import { useHasScope } from '../accountsQueries';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const HasScope = ({
  scope,
  fallback = /*#__PURE__*/_jsx(_Fragment, {}),
  children,
  override
}) => {
  const {
    hasScope
  } = useHasScope(scope);
  if (hasScope && !override) return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: fallback
  });
};